import script from "./ExtendedFilteredProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtendedFilteredProducts.vue?vue&type=script&setup=true&lang=ts"

import "./ExtendedFilteredProducts.vue?vue&type=style&index=0&id=074b7d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074b7d6e"]])

export default __exports__